// extracted by mini-css-extract-plugin
export default {"baseLayout":"BaseLayout_baseLayout__2OBaD","content":"BaseLayout_content__KLDRS"};